export default "__VITE_ASSET__Bvml68hD__"